import { Fgv } from '@/app/fgv/entities/fgv.entity'

export interface FgvState {
    fgvs: Fgv[]
}

export const state: FgvState = {
    fgvs: []
}
